import { NIL, validate } from 'uuid';

export const useFriendlyKeyHelper = (id: string) => {
	if (id && validate(id)) {
		return { id, key: '' };
	} else {
		return { id: NIL, key: id };
	}
};
